export const getTenantId = () => {
    return localStorage.getItem('tenantId');
  };
  
  export const getToken = () => {
    return localStorage.getItem('token');
  };
  